import type {
  AuditLog,
  AuditLogDTO,
} from '@src/models/interfaces/AuditLog/AuditLogInterface';
import type { ElasticSearchHit } from '@src/models/interfaces/general/ElasticSearchResponseInterface';
import { DateUtil } from '@src/packages/utils/dates';

export class AuditLogMapper {
  static fromElasticHit(hit: ElasticSearchHit<AuditLogDTO>): AuditLog {
    const createdAt = DateUtil.getTimestampMs(hit._source.createdAt) ?? 0;

    return {
      ...hit._source,
      id: hit._id,
      key: hit._id,
      createdAt,
      extraKeys: hit._source.extraKeys ?? {},
    };
  }
}
